import 'angular:locale/data:pl';
import 'angular:locale/data:de';
import 'angular:locale/data:da';
import 'angular:locale/data:en';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
